import Vue from 'vue';
import gridProps from '@/gridProps';

import {
  formatNumber,
  LinkCellRenderer,
  autoResize,
  alignCells
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
  sumTotalData
} from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    operations: [],
    columns: [],
    totalData: [
      {
        label: 'total_operations',
        value: 0
      },
      {
        label: 'from_stock_t',
        value: 0,
        key: 'from_stock_weight'
      },
      {
        label: 'to_stock_t',
        value: 0,
        key: 'to_stock_weight'
      }
    ],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      rowGroupPanelShow: 'always',
      groupSelectsChildren: true,
      components: {
        'SalesOrderLink': LinkCellRenderer('sales_order_id', '/sales-orders/'),
        'OperationLink': LinkCellRenderer('id', '/operation/')
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        valueFormatter(params) {
          return formatNumber(params.value, null);
        },
        cellStyle(params) {
          return alignCells(params);
        },
        tooltipValueGetter(params) {
          const rowData = params.data;
          if (rowData) {
            if (!rowData.auto_calc) {
              return 'Off auto calculation'
            } else if (rowData.zero_cost) {
              return 'Operation has packages with cost = 0'
            } else if (rowData.zero_purchase_price) {
              return 'Purchase price = 0'
            } else if (rowData.cost_equal_to_process_price) {
              return 'Operation has packages which purchase price is equal and cost'
            }
          }
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      },
      getRowStyle(params) {
        const rowData = params.data;
        if (rowData) {
          if (!rowData.auto_calc || rowData.zero_cost) {
            return {'background': '#ff7d7d'};
          } else if (rowData.zero_purchase_price || rowData.cost_equal_to_process_price) {
            return {'background': '#f9c292'};
          }
        }
      }
    },
    gridName: ''
  },
  getters: {
    operations(state) {
      return state.operations;
    },
    columns(state) {
      return state.columns;
    },
    gridOptions(state) {
      return { ...gridProps, ...state.gridOptions };
    },
    totalData(state) {
      return state.totalData;
    }
  },
  mutations: {
    setData(state, payload) {
      state.operations = payload.data;
      state.columns = addColIdToColumns(payload.used_columns);
      state.gridName = payload.grid_name;
    },
    setTotalData(state, payload) {
      state.totalData = sumTotalData(payload, state.totalData);
    }
  },
  actions: {
    async loadOperations(store, payload) {
      try {
        const response = await Vue.http.get('woodware/search_for_movement/', {params: payload}).then(handlerResponse);
        store.commit('setData', response);
        store.commit('setTotalData', response.data);
      } catch (e) {
        console.log(e);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/manufacture/operations/operations.js